<template>
  <!--<section class="app-main" style="min-height:100%;background:#fbfbfb">-->
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!--<keep-alive :include="cachedViews">-->
      <router-view :key="key"></router-view>
      <!--</keep-alive>-->
    </transition>
  </section>
</template>

<script>
  export default {
    name: 'AppMain',
    computed: {
      // cachedViews() {
      //   // console.log(this.$store.state.tagsView.cachedViews)
      //   return this.$store.state.tagsView.cachedViews
      // }
      key() {
        return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue